import React from 'react';

import { IconButton, makeStyles, Tooltip } from '@material-ui/core';
import clsx from 'clsx';

const useStyles = makeStyles({
  icon: {
    height: 38,
    width: 38,

    '& svg': {
      width: 24,
      height: 24,
    },
    '&:hover': {
      background: 'rgba(75, 140, 111, 0.18)',

      '& svg': {
        fill: '#4b8c6f',
      },
    },
  },
  selectedIcon: {
    '& svg': {
      fill: '#4b8c6f',
    },
  },
});

export const SrIconButton = ({
  Icon,
  selected = false,
  tooltip = false,
  disabled = false,
  ...props
}) => {
  const classes = useStyles();

  const WrapInTooltip = ({ children }) => {
    if (tooltip) {
      return (
        <Tooltip title={tooltip}>
          {disabled ? <span>{children}</span> : children}
        </Tooltip>
      );
    }
    return children;
  };

  return (
    <WrapInTooltip>
      <IconButton
        disabled={disabled}
        classes={{
          root: clsx(classes.icon, { [classes.selectedIcon]: selected }),
        }}
        {...props}
      >
        <Icon />
      </IconButton>
    </WrapInTooltip>
  );
};

export default SrIconButton;
